<template>
  <div class="item-block">
    <p class="setting-title tc">Contact Setting</p>
    <vue-plupload
        class-name="upload-btn setting-btn btn"
        text="Upload a VCF"
        @init="handleUploaderInit"
        @error="handleError"
        @added="handleAdded">
    </vue-plupload>
    <span v-if="showUploadError" class="error">{{ uploadError }}</span>
  </div>
</template>

<script>
import loading from "../../common/utils/loading";
import VuePlupload from "./vue-plupload.vue";
import adminService from '../service/adminService';

export default {
  name: "upload-vcf",
  components: {
    'vue-plupload': VuePlupload,
  },
  data() {
    return {
      uploadError: ''
    }
  },
  computed: {
    uploadOpt() {
      return {
        url: adminService.getUploadURL(),
        filters: {
          multi_selection: false,
          max_file_size: '2mb',
          mime_types: [{
            title: "Document files",
            extensions: "vcf"
          }]
        },
      };
    },

    showUploadError() {
      return this.uploadError && this.uploadError.length > 0;
    },

  },
  methods: {
    /**
     * uploader
     */
    handleUploaderInit(uploader) {
      uploader.setOption(this.uploadOpt);
    },

    handleAdded: function (uploader, files) {
      const file = files[0];
      if (file) {
        loading.show();
        (new Promise(resolve => {
          const reader = new FileReader();
          reader.addEventListener("load", function () {
            // convert image file to base64 string
            resolve(reader.result);
          }, false);
          reader.readAsDataURL(file.getNative());
        }))
            .then((itemUrl) => {
              adminService.editBlock("Contact", 2, itemUrl,
                  0, null, `<i class="ri-fw ri-contacts-book-line"></i>`)
                  .then((res) => {
                    this.$emit("update");
                    console.log(res);
                  })
            })
            .finally(() => {
              uploader.removeFile(file);
            })
      }
    },

    handleError: function (uploader, err) {
      // console.error(err);
      const file = err.file || {};
      const filename = file.name || '';
      const msg = err.message;
      this.uploadError = `${filename} ${msg}`;
    },
  }

}
</script>
